package er.prateek.crossly.ads

import er.prateek.crossly.ads.entitlement.Entitlement

/**
 * The "may we?" half of the ads decision, separated from the "how often?" half in
 * [AdFrequencyController] because it has no state and no clock -- which makes the one rule
 * that must never break, `adFree` beats everything, a single line that is trivially
 * verifiable.
 */
object AdsPolicy {

    /**
     * The gate every other check is built on. A paying user is never asked again by any
     * format, on any platform, regardless of what Remote Config says -- the config is a
     * business lever, the entitlement is a promise.
     */
    fun adsAllowed(config: AdsConfig, entitlement: Entitlement): Boolean =
        config.enabled && !entitlement.adFree

    fun bannerAllowed(config: AdsConfig, entitlement: Entitlement, placement: AdPlacement): Boolean {
        if (!adsAllowed(config, entitlement)) return false
        if (!config.banner.enabled) return false
        return placement.wireName in config.banner.placements
    }

    fun interstitialAllowed(config: AdsConfig, entitlement: Entitlement): Boolean =
        adsAllowed(config, entitlement) && config.interstitial.enabled

    fun rewardedAllowed(config: AdsConfig, entitlement: Entitlement): Boolean =
        adsAllowed(config, entitlement) && config.rewarded.enabled
}
